Vue.component("MpModuleNewsletterAdvice", {
    mixins: [MpMailchimpSubscription],

    data: function() {
        return {
            HIDING_DELAY: 6000,
            OFFSET_TOP: 600,

            isShown: false,
            isCookieNewsletter: false,
            isLegalShown: false,
            isClosed: false,
        };
    },

    computed: {
        legalTriggerLabel: function() {
            return (this.isLegalShown) ? this.LABEL_LEGAL_INFO_HIDE : this.LABEL_LEGAL_INFO_SHOW;
        },
    },

    methods: {

        close: function() {
            this.saveCookieNewsLetter(false);
            this.isClosed = true;
        },

        onCookieNewsletterSaved: function() {
            setTimeout(() => {
                this.isCookieNewsletter = true;
            }, this.HIDING_DELAY);
        },

        detectScroll: function() {
            window.addEventListener('scroll', this.scrollHandler);
        },

        scrollHandler: function(event) {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            if (scrollTop > this.OFFSET_TOP) {
                this.showAdviceNewsletter();
            }
        },

        showAdviceNewsletter: function() {
            this.isShown = true;
            window.removeEventListener('scroll', this.scrollHandler);
        },

        init: function() {
            this.isCookieNewsletter = CookieManager.getCookie('mp_cookie_newsletter_subcribed') !== null;
            this.detectScroll();
        },

        toggleLegalConditions: function(ev) {
            this.isLegalShown = !this.isLegalShown;
        }
    },

    mounted: function() {
        this.init();
    },

    template: '\
    <div class="toast" :class="{\'toast--show\' : isShown}" v-if="!isCookieNewsletter && !isClosed">\
        <div class="toast__inner">\
            <a class="toast__close" href="#" @click.prevent="close">\
                <svg class="toast__close-icon" width="14" height="14" xmlns="http://www.w3.org/2000/svg">\
                    <path d="M13.984 1.422L8.406 7l5.578 5.578-1.406 1.406L7 8.406l-5.578 5.578-1.406-1.406L5.594 7 .016 1.422 1.422.016 7 5.594 12.578.016z" fill="currentColor" fill-rule="evenodd"></path>\
                </svg>\
            </a>\
            <div class="toast__content">\
                <form class="newsletter__form form" action="https://mundopetroleo.us12.list-manage.com/subscribe/post-json" method="get" ref="mcform">\
                    <input type="hidden" name="b_f760987f51ffd7d4bc0d46264_1f1a07a14d" tabindex="-1" value="">\
                    <div class="row align-items-center">\
                        <div class="col-12 col-md-auto">\
                            <h5 class="newsletter__title">Suscríbase a nuestro newsletter</h5>\
                        </div>\
                        <div class="col-12 col-md-4 col-lg-6 newsletter__form-group mc-field-group">\
                            <input class="newsletter__form-control form-control required email" type="email" value="" name="EMAIL" id="mce-EMAIL" placeholder="Introduzca su correo electrónico" v-model="email">\
                        </div>\
                        <div class="col-12 col-md-auto">\
                            <a class="newsletter__form-btn btn btn--block btn--tertiary u-text-uppercase" @click.prevent="doSubscription()">Suscribirme</a>\
                        </div>\
                    </div>\
                    <div class="row">\
                        <div class="col">\
                            <p class="newsletter__message newsletter__message--ok" v-show="successMessage">{{successMessage}}</p>\
                            <p class="newsletter__message newsletter__message--ko" v-show="errorMessage" v-html="errorMessage"></p>\
                        </div>\
                    </div>\
                    <div class="row">\
                        <div class="col-auto">\
                            <div class="newsletter__legal" :class="{\'newsletter__legal--closed\': !isLegalShown}">\
                                <h5 class="newsletter__legal-trigger" @click="toggleLegalConditions"><span class="u-mr-xxxs">⚠️</span> {{legalTriggerLabel}}</h5>\
                                <div class="newsletter__legal-conditions">\
                                    <p>Según normativa actual de Protección de Datos de Carácter Personal, se informa que el Responsable del Tratamiento de sus datos es MUNDOPETROLEO PETRORED, SL. Sus datos serán tratados con la finalidad de enviarle el boletín emitido por nuestra entidad o las noticias y servicios que puedan ser interesantes para su entidad. La legitimación está basada en el consentimiento por parte del interesado. No se cederán datos a terceros, salvo obligación legal. Los datos serán destruidos una vez que comunique usted su baja o finalizados los períodos legales de conservación. En caso de utilizar servicios de marketing externos, sus datos podrán ser cedidos a empresas prestadoras de servicios de marketing por correo electrónico las cuales se encuentran adheridas al escudo de PRIVACY SHIELD.</p>\
                                    <p class="u-mb-0">Los interesados podrán ejercitar sus derechos de acceso, rectificación, supresión, oposición, portabilidad o limitación del tratamiento, dirigi&eacute;ndose a&nbsp; MUNDOPETROLEO PETRORED, SL en la siguiente dirección: Polígono de Salcedo II, Parc. D3, Navia (33710), Asturias, España.&nbsp; Igualmente, puede presentar una reclamación ante la Agencia Espa&ntilde;ola de Protección de datos si considera que sus derechos han sido vulnerados.</p>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                </form>\
            </div>\
        </div>\
    </div>',
});
